<template>
	<div>
		<div class="filter-toolbar">
			<span class="title">{{ $t('WEBAPP_MONETIZATIONTYPES') }}</span>
			<ResetButton :filterNames="['monetization_types']" />
		</div>

		<div class="jw-padding" style="display: flex; flex-flow: wrap">
			<ToggleButton
				v-for="option in options"
				:key="option.value"
				:active="isFilterActive('monetization_types', option.value)"
				:icon="'jw-check-icon'"
				@click.prevent="clicked(option.value)"
			>
				{{ $t(option.label) }}
			</ToggleButton>
		</div>
	</div>
</template>

<script setup lang="ts">
import ToggleButton from '@/ui-components/ToggleButton.vue';
import ResetButton from '@/components/buttons/ResetButton.vue';

import { useFilterStore } from '@/stores/pinia/useFilterStore';
import type { FilterCollection, FilterName } from '@/stores/useFilterStoreTypes';
import { isFilterActive as filterActive } from '@/helpers/filter-helper';

import { CollectionType } from '../../enums/collection-type';
import { MonetizationTypes } from '@/interfaces/titles';
import { MonetizationType } from '@/@types/graphql-types';

const router = useRouter();

const filterStore = useFilterStore();

const props = defineProps<{
	collectionType: CollectionType;
	currentFilters: FilterCollection;
}>();

const options =
	// not all monetization options shoudl be shown, there are some
	// that should not be selected
	MonetizationTypes.filter(f => f.visible) // show only visible types
		.sort((a, b) => a.priority - b.priority); // order by priority ASC

function isFilterActive(filterName: FilterName, value: any) {
	return filterActive(filterName, value, props.currentFilters);
}

async function clicked(monetizationType: MonetizationType) {
	const selectedState = isFilterActive('monetization_types', monetizationType) ? 0 : 1;
	const newRoute = await filterStore.toggle({
		filterName: 'monetization_types',
		value: monetizationType,
		selectedState,
	});

	if (newRoute) router.push(newRoute);
}
</script>

<style lang="scss"></style>
